import * as ActionTypes from '../constants/ActionTypes';

export function clearEntities(type) {
  return {
    type: ActionTypes.CLEAR_ENTITIES,
    payload: type
  };
}

export function clearEntity(data, type) {
  return {
    type: ActionTypes.CLEAR_ENTITY,
    data: data,
    entity: type
  }
}

export function receiveEntities(data, type) {
  return {
    type: ActionTypes.RECEIVE_ENTITIES,
    data: type ? data.map(d => { d.type = type; return d }) : data
  };
}

export function receiveEntity(data, type) {
  if (type) data.type = type;

  return {
    type: ActionTypes.RECEIVE_ENTITY,
    data: data
  };
}



// WEBPACK FOOTER //
// ./src/actions/entities.js